export default {
  "dashboard.analysis.test": "Gongzhuan No.{no} shop",
  "dashboard.analysis.introduce": "Introduzir",
  "dashboard.analysis.total-sales": "Vendas Totais",
  "dashboard.analysis.day-sales": "Vendas do Dia",
  "dashboard.analysis.visits": "Visitas",
  "dashboard.analysis.visits-trend": "Tendência de Visitas",
  "dashboard.analysis.visits-ranking": "Ranking de Visitas",
  "dashboard.analysis.day-visits": "Visitas do Dia",
  "dashboard.analysis.week": "Taxa Semanal",
  "dashboard.analysis.day": "Taxa Diária",
  "dashboard.analysis.payments": "Pagamentos",
  "dashboard.analysis.conversion-rate": "Taxa de Conversão",
  "dashboard.analysis.operational-effect": "Efeito Operacional",
  "dashboard.analysis.sales-trend": "Tendência de Vendas das Lojas",
  "dashboard.analysis.sales-ranking": "Ranking de Vendas",
  "dashboard.$2": "Todo ano",
  "dashboard.analysis.all-month": "Todo mês",
  "dashboard.analysis.all-week": "Toda semana",
  "dashboard.analysis.all-day": "Todo dia",
  "dashboard.analysis.search-users": "Pesquisa de Usuários",
  "dashboard.analysis.per-capita-search": "Busca Per Capta",
  "dashboard.analysis.online-top-search": "Mais Buscadas Online",
  "dashboard.analysis.the-proportion-of-sales": "The Proportion Of Sales",
  "dashboard.channel.all": "Tudo",
  "dashboard.channel.online": "Online",
  "dashboard.channel.stores": "Lojas",
  "dashboard.analysis.sales": "Vendas",
  "dashboard.analysis.traffic": "Tráfego",
  "dashboard.table.rank": "Rank",
  "dashboard.table.search-keyword": "Palavra chave",
  "dashboard.table.users": "Usuários",
  "dashboard.table.weekly-range": "Faixa Semanal",
};
